import {ChangeDetectorRef, Component, forwardRef, HostListener} from "@angular/core";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {FUIAbstractCheckboxInput} from "../abstract-checkbox-input";

@Component({
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FUIFilterCheckboxInputComponent),
            multi: true
        }
    ],
    selector: "fui-filter-checkbox-input",
    styleUrls: ["./filter-checkbox-input.component.scss"],
    templateUrl: "./filter-checkbox-input.component.html"
})
export class FUIFilterCheckboxInputComponent extends FUIAbstractCheckboxInput {
    constructor(changeDetectorRef: ChangeDetectorRef) {
        super(changeDetectorRef);
    }
}
